import { useEffect } from 'react';//NEW
import { useLocation } from 'react-router-dom';//NEW
import React, { useState } from 'react';
import "../Auth.scss";
import { Button, Spinner, FormControl, InputGroup } from 'react-bootstrap';
import peopleVideocall from "../../../assets/img/people-videocall.jpg";
import loginAiss from "../../../assets/img/aiss_he_login.jpg";//NEW
import loginFederpol from "../../../assets/img/Federpol-corsi-500x500.jpg";//NEW 
import loginDifesaonline from "../../../assets/img/difesaonline_he_login.jpg";
import unlockLogo from "../../../assets/img/unlock-logo.svg";
import hat from "../../../assets/img/graudation-hat-1.svg";
import {useNavigate} from 'react-router';
import useAuth from '../../../hooks/useAuth';
import { useDispatch } from 'react-redux';
import { setLoggedUser } from '../../../store/actions/user'; 
import { decodeToken } from "react-jwt";
import { ROLES } from '../../../model/roles';
import { alertService } from '../../../services/AlertService';


const AccediForm = ({fetchCompleteProfile}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [hashedPassword, setHashedPassword] = useState('');
  const {isLoading, login, resetPassword, loadingState} = useAuth();
  const [changePasswordStatus, setChangePasswordStatus] = useState(null);
  const [checkingRedirect, setCheckingRedirect] = useState(true);//NEW

  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();//NEW
  useEffect(() => {//NEW
    const params = new URLSearchParams(location.search);
    const token = params.get('str_confirm');
    const username = params.get('username');
  
    if (username) { // <-- AGGIUNGIAMO QUESTA CONDIZIONE
      setEmail(username?.trim() ?? ''); 
    }
  
    if (token && username) {
      loginConToken(username?.trim(), token).finally(() => {
        setCheckingRedirect(false); // finito il controllo
      });
    } else {
      setCheckingRedirect(false); // nessun login da fare
    }
  }, [location.search]);

  const loginConToken = async (username, confirmToken) => {//NEW
    const res = await login({ username, confirm_token: confirmToken });
    if (res?.cambio_password) {
      setHashedPassword(res?.hashed_password);
      setChangePasswordStatus(res);
    } else {
      if(res?.profilo_da_completare === 1) {//NEW
        const res = {...res, confirmToken}
        fetchCompleteProfile(res);
      }
      else{
        responseLogin(res);
      }
    }
  };

  const onResetPassword = async () => {
    if(newPassword !== newPassword2) {
        alertService.warn("Le password non coincidono", {autoClose: true});
        return;
    }
    const obj = {
        old_password: password?.trim(),
        new_password: newPassword?.trim(),
        username: email?.trim(),
        old_hpassword: hashedPassword
    }
    const res = await resetPassword(obj, changePasswordStatus?.access_token);
    if(res) { 
        if(changePasswordStatus?.profilo_da_completare === 1){
            const response = {...changePasswordStatus, newPassword}
            fetchCompleteProfile(response)
        }
        if(changePasswordStatus?.profilo_da_completare === 0){
            responseLogin(changePasswordStatus);
        }
    }
  }

  const onLogin = async () => {
    const trimmedEmail = email?.trim() ?? '';
    const trimmedPassword = password?.trim() ?? '';
    if (trimmedEmail !== '' && trimmedPassword !== '') {
        const obj = { username: trimmedEmail, password: trimmedPassword };
        const response = await login(obj);
        if(response?.profilo_da_completare === 1) {
            //alert(response?.id_superpartner_registrazione_corsista);
            if(response?.id_superpartner_registrazione_corsista){//NEW
                localStorage.setItem("idSP", response?.id_superpartner_registrazione_corsista);
            }

            if(!!response.cambio_password) {
                const res = {...response, password: trimmedPassword}
                setChangePasswordStatus(res)
                return;
            }
            const res = {...response, password: trimmedPassword}
            fetchCompleteProfile(res)
        }
        
        if(response?.profilo_da_completare === 0) {
            fetchCompleteProfile(null)
            if(response?.success) {
                if(!!response.cambio_password) {
                    setChangePasswordStatus(response)
                    return;
                }
                responseLogin(response);
            }
        }
    }
  };

  const responseLogin = (response) => {
    let idSPToAssign = null;
    if (response?.id_superpartner != null && response?.id_superpartner !== '') {
      idSPToAssign = String(response.id_superpartner);
    } else if (
      response?.id_superpartner_registrazione_corsista != null &&
      response?.id_superpartner_registrazione_corsista !== ''
    ) {
      idSPToAssign = String(response.id_superpartner_registrazione_corsista);
    }
    if (idSPToAssign) {
      localStorage.setItem('idSP', idSPToAssign);
    } else {
      localStorage.removeItem('idSP');
    }

    localStorage.setItem("token", response?.access_token)
    localStorage.setItem("refresh_token", response?.refresh_token)
    localStorage.setItem("username", response?.username);//NEW
    const token = decodeToken(response?.access_token);
    dispatch(setLoggedUser(token));
    const rid = Number(token.role);
    if(rid === ROLES.CORSISTA) {
        navigate("/corsi")
    } else if (rid === ROLES.ADMIN || rid === ROLES.SUPERADMIN) {
        navigate("/admin-dashboard")
    } else if (token.role === ROLES.COURSE_DESIGNER || token.role === ROLES.DEVELOPER || token.role === ROLES.DOCENTE) {
        navigate("/gestione-corsi")
    // --- BLOCCO MODIFICATO/AGGIUNTO ---
    } else if(token.role === ROLES.PARTNER || token.role === ROLES.SUPERPARTNER){ // <-- Aggiunto ROLES.SUPERPARTNER qui
        navigate("/gestione-utenti") // <-- Reindirizziamo a gestione-utenti
    // ------------------------------------
    /*    
    } else if(token.role === ROLES.PARTNER){
        navigate("/corsi")//NEW
        //navigate("/gestione-utenti")
    */
    } else if(token.role === ROLES.TUTOR){
        navigate("/area-personale/classi")
    } else if (rid === ROLES.ISPETTORE) {
        navigate("/area-ispezione")
    }
  }

  const idSP = localStorage.getItem("idSP");//NEW
    var loginImg = peopleVideocall;
    var textMuted = "Non hai un account?";
    var textButton = "Registrati";
    var textLogin = "";
    if(idSP == 1){//Aiss
        loginImg = loginAiss;
        textMuted = "";
        textButton = "Se non hai le credenziali di accesso, clicca qui per effettuare la richiesta";
        textLogin = "A.I.S.S.";
    }
    else if(idSP == 2){//Federpol
        loginImg = loginFederpol;
        textMuted = "";
        textButton = "Se non hai le credenziali di accesso, clicca qui per effettuare la richiesta";
        textLogin = "Federpol";
    }
        else if(idSP == 3){//Difesaonline
        loginImg = loginDifesaonline;
        textMuted = "";
        textButton = "Se non hai le credenziali di accesso, clicca qui per effettuare la richiesta";
        textLogin = "Difesaonline";
    }
    ///////////////////////////////
    if (checkingRedirect) {//NEW
        return (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Spinner animation="border" variant="primary" />
        </div>
        );
    }
  return (
    
    <form  className="auth-form">
    <div className="d-flex align-items-center justify-content-center my-5">
            <div className="container my-5">
                <div className={`card authCard rounded shadow`}>
                    <div className="row"  style={{ minHeight: '600px' }}>
                        <div className="col-sm-12 col-md-12 col-xl-6 order-xl-1 order-2">
                            {
                                changePasswordStatus ?  
                                <div className="form-content fade-in-down">
                                <div style={{margin: '0 auto', textAlign: 'center'}}>
                                    <img src={unlockLogo} style={{width: '72px'}} alt="lucchetto"/>
                                </div>
                                <h3 className="text-center my-3">Crea password</h3>
                                <div className="d-flex my-2">
                                    <i className="bi bi-key fs-5 align-self-center me-2 text-muted"></i>
                                    <input required value={newPassword} onChange={(e) => setNewPassword(e.target.value)} type="password" placeholder="Nuova password" className="form-control form-control-lg my-2 login-psw" aria-describedby="passwordHelpBlock" />
                                </div>
                                <div className="d-flex my-2">
                                    <i className="bi bi-key fs-5 align-self-center me-2 text-muted"></i>
                                    <input required value={newPassword2} onChange={(e) => setNewPassword2(e.target.value)} type="password" placeholder="Ripeti nuova password" className="form-control form-control-lg my-2 login-psw" aria-describedby="passwordHelpBlock" />
                                </div>
                                {isLoading ? (
                                <Button variant="primary" disabled className="my-3 w-100">
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Caricamento...
                                </Button>
                                ) : (
                                    <Button type="button" onClick={onResetPassword} className="btn btn-primary my-3 w-100">
                                        Salva
                                    </Button>
                                )}
                                <small className="text-muted d-block mt-2">
                                    La tua nuova password deve avere lunghezza minima 8 caratteri e avere al suo interno:<br></br>- una lettera minuscola<br></br>- una lettera maiuscola<br></br>- un numero<br></br>- un carattere speciale tra: <strong>! @ # $ % ^ * ( ) - _ + = ?</strong>
                                </small>
                                </div>
                                
                                : 
                             <div className="form-content">
                                <div className="d-flex justify-content-center">
                                    <img src={hat} width="70" alt="cappello laurea" />
                                    <h2 className="text-center my-3"> <b>Bentornato</b></h2>
                                </div>
                                <div className="d-flex">
                                    <i className="bi bi-envelope fs-5 align-self-center me-2 text-muted"></i>
                                    <input required value={email} onChange={(e) => setEmail(e.target.value)} onBlur={(e) => setEmail(e.target.value?.trim())} className="form-control form-control-lg my-2" type="text" placeholder="E-mail" aria-label="E-mail" />
                                </div>
                                <div className="d-flex my-2">
                                    <i className="bi bi-key fs-5 align-self-center me-2 text-muted"></i>
                                    <InputGroup className="flex-grow-1 my-2">
                                        <FormControl required value={password} onChange={(e) => setPassword(e.target.value)} onBlur={(e) => setPassword(e.target.value?.trim())} type={showPassword ? "text" : "password"} placeholder="Password" size="lg" className="login-psw" aria-describedby="passwordHelpBlock" />
                                        <InputGroup.Text style={{ cursor: 'pointer' }} onClick={() => setShowPassword(!showPassword)} title={showPassword ? "Nascondi password" : "Mostra password"} aria-label={showPassword ? "Nascondi password" : "Mostra password"}>
                                            <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"} aria-hidden="true"></i>
                                        </InputGroup.Text>
                                    </InputGroup>
                                </div>
                                <p className="text-end mt-2 mb-3"><span role='button' onClick={() => navigate("/password-dimenticata")} className="text-muted"><u>Password dimenticata?</u></span></p>
                               
                                {loadingState.isLoadingLogin ? (
                                <Button variant="primary" disabled className="my-3 w-100">
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                    Accedi...
                                </Button>
                                ) : (
                                    <Button type="button" onClick={onLogin} className="btn btn-primary my-3 w-100">
                                        Accedi
                                    </Button>
                                )}
                                <p><span className='text-muted'>{textMuted}</span> <span role='button' onClick={() => navigate("/registrati")}><u>{textButton}</u></span></p>
                            </div>
                            }
  
                        </div>
                        <div className="col-sm-12 col-md-12 col-xl-6 order-xl-2 order-1">
                            <div className="info-content d-flex align-items-center justify-content-center text-light login-page">
                                <img className="info-img" src={loginImg} alt="" />
                                <h1>Accedi al tuo account <span className="text-primary">H</span>igh <span className="text-primary">E</span>ducational<br></br>{textLogin}</h1>
                            </div>
                        </div>
                    </div>
                </div>
         </div>
        </div>
    </form>
  );
}

export default AccediForm;
